// Generated by ReScript, PLEASE EDIT WITH CARE


function toString(action) {
  switch (action) {
    case /* Approve */0 :
        return "Approve";
    case /* Discard */1 :
        return "Discard";
    case /* Delete */2 :
        return "Delete";
    
  }
}

export {
  toString ,
  
}
/* No side effect */
